import { Center } from "@chakra-ui/react";

// width/height opcionais (default = tamanho fixo de sempre, usado no helper
// de ajuda de questão) — a grade de Aulas e Materiais passa "100%" pra caber
// no card, ver pages/educational-content/index.jsx.
export default function VideoFrame({ videoUrl, width = "591", height = "329" }) {
  const getYouTubeID = (url) => {
    const regex =
      /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?/ ]{11})/;
    const match = url.match(regex);
    return match ? match[1] : null;
  };

  const videoID = getYouTubeID(videoUrl);

  return (
    <Center h="100%" w="100%">
      <iframe
        width={width}
        height={height}
        src={`https://www.youtube.com/embed/${videoID}`}
        title="Vídeo de Ajuda"
        allowFullScreen
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      />
    </Center>
  );
}
